import React from 'react';
import PropTypes from 'prop-types';
import {useParams} from 'react-router-dom';
import data from '../lang/arsskyrsla-data.json';
import {Grid, GridItem, Heading, Text, useBreakpointValue} from '@chakra-ui/react';
import BasePage from "./BasePage";
import {ImageWithLegend} from '../components';
import Navbar from '../components/navBar/NavBar';

function SeeMorePage({type}) {
    SeeMorePage.propTypes = {
        type: PropTypes.string.isRequired,
    };
    const {id} = useParams();
    const seeMorePage = data.versions[0].seeMorePages.find((item) => item.id === parseInt(id));
    const dataImage = {
        "image": seeMorePage.image,
        "mobileImage": seeMorePage.mobileImage,
        "imageLegend": seeMorePage.imageLegend
    }

    const isMobile = useBreakpointValue({base: true, md: false});
    const menuItems = data.versions[0].topMenu.menuItems;
    return (

        <React.Fragment>
            <Navbar menuItems={menuItems} onHomepage={false}/>
            <Grid
                templateColumns={`repeat(${isMobile ? 4 : 12}, 1fr)`}
                columnGap={isMobile ? "24px" : "32px"}
                rowGap={isMobile ? "0px" : "20px"}
                pl={isMobile ? "16px" : "48px"}
                pr={isMobile ? "16px" : "48px"}
            >
                <GridItem colStart={isMobile ? 1 : 2} colEnd={isMobile ? 5 : 12}>
                    <BasePage type={type}/>
                </GridItem>
                <GridItem colStart={isMobile ? 1 : 4} colEnd={isMobile ? 5 : 10}>
                    <ImageWithLegend data={dataImage}/>
                </GridItem>
                {seeMorePage.simplePostColumns.map((element, index) => (
                    <React.Fragment key={index}>
                        <GridItem colStart={isMobile ? 1 : 2} colEnd={5} pb={isMobile ? "32px" : "" }>
                            <Heading variant="heading5">
                                {element.title}
                            </Heading>
                        </GridItem>
                        <GridItem colStart={isMobile ? 1 : 6} colEnd={isMobile ? 5 : 11} mb={seeMorePage.simplePostColumns.length === index + 1 ? isMobile ? "112px" : "134px" : isMobile && "72px"}>
                            <Text whiteSpace="pre-line" textStyle="customBodyMedium">
                                {element.text}
                            </Text>
                        </GridItem>
                    </React.Fragment>
                ))}
            </Grid>
        </React.Fragment>
    );
}

export default SeeMorePage;